import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from './style.js';
import loadingImage from '../../../images/instore/loading.gif';

const LiveAR = props => {
  const [liveARModuleLoaded, setLiveARModuleLoaded] = useState(false);

  useEffect(() => {
    const { sdk } = props;
    if (!sdk.liveAR.mounted) {
      sdk.liveAR.initialize({ renderToSelector: '#liveARContainer', eventHandler: liveAREventHandler });
    }
    return () => {
      sdk.liveAR.release();
    };
  }, []);

  const liveAREventHandler = ({ type, state }) => {
    if (type === 'statusChanged' && state === 'renderingEffects') {
      setLiveARModuleLoaded(true);
    }
  };

  return (
    <styled.container>
      {!liveARModuleLoaded && (
        <styled.loading>
          <styled.image src={loadingImage} alt="loading" />
          <br />
          Starting Virtual Tryon
        </styled.loading>
      )}
      <styled.canvas id="liveARContainer" />
    </styled.container>
  );
};

LiveAR.propTypes = {
  sdk: PropTypes.object.isRequired,
};

export default LiveAR;



// WEBPACK FOOTER //
// ./src/components/instore/LiveAR/LiveAR.js